import React, { ReactElement } from 'react'
import Modal from 'react-modal'
import { IModalContainerProp } from '../../interfaces/IModal'

function ModalContainer(props: IModalContainerProp): ReactElement {
  const { isOpen, children, portalClassName } = props

  const ModalAny = Modal as any

  return (
    <ModalAny
      isOpen={isOpen}
      ariaHideApp={false}
      portalClassName={portalClassName}
    >
      <div role="dialog">{children}</div>
    </ModalAny>
  )
}

export default ModalContainer
